import {inject} from '@angular/core';
import {BaseSpringServiceCB, ExpiredTokenError, SpringRestService} from '@aiknow-srl/aik-ngx-http';
import {GlobalModelService} from "../GlobalModel.service";
import {BaseService} from "../BaseService";
import {HttpErrorResponse} from "@angular/common/http";
import {ToastService} from "../toast.service";
import {Observable} from "rxjs";
import {SpinnerService} from "../spinner.service";
import {AuthStateService} from "../auth/auth-state.service";

export abstract class BaseOPEService extends BaseService {

  // ******************************************************
  //                 Dependency Injection
  // ******************************************************
  protected be = inject(SpringRestService);
  protected toastService = inject(ToastService);
  private gmService = inject(GlobalModelService);
  protected authState = inject(AuthStateService);
  protected spinnerService = inject(SpinnerService);

  cleanupServiceFields(): void {
    // doNothing
  }

  protected execOPE(cb: BaseSpringServiceCB, showSpinner: boolean = true): Promise<Object> {
    return new Promise<any>((resolve, reject) => {
      if (showSpinner) this.spinnerService.addHTTPRequest();
      this.be.execOPE(this.gmService.composeUrl(), cb).then((_) => {
        resolve(_);
        if (showSpinner) this.spinnerService.removeHTTPRequest();
      }, (error: HttpErrorResponse | ExpiredTokenError | string) => {

        // Error handling
        if (showSpinner) this.spinnerService.removeHTTPRequest();
        this.manageOPEError(error);
        reject(error);

      });
    });
  }

  protected execMultipartOPE(cb: BaseSpringServiceCB): Observable<any> {
    const formData = new FormData();
    for (const key of Object.keys(cb.i)) {
      formData.append(key, cb.i[key]);
    }

    return new Observable((subscriber) => {
      this.be.uploadFile(this.gmService.composeUrl() + "/" + cb.serviceName, formData).forEach(response => {
        if (response.type === 1) {
          subscriber.next(
            {
              perc: response.loaded / response.total * 100,
              type: response.type
            }
          )
        } else if (response.type === 4) {
          cb.o = response.body.o;
          subscriber.complete()
        } else {
          subscriber.next(
            {
              type: response.type
            }
          )
        }
      }).catch(((error: HttpErrorResponse | ExpiredTokenError | string) => {

          // Error handling
          this.manageOPEError(error);
          subscriber.error(error);
        }
      ))
    })
  }

  protected execOPEWithTempToken(cb: BaseSpringServiceCB, token: string): Promise<Object> {
    return new Promise<any>((resolve, reject) => {
      this.authState.useTemporaryToken(token);
      this.be.execOPE(this.gmService.composeUrl(), cb).then((_) => {
        resolve(_);
      }, (error: HttpErrorResponse | ExpiredTokenError | string) => {

        // Error handling
        this.manageOPEError(error);
        reject(error);

      });
    });
  }

  private manageOPEError(error: HttpErrorResponse | ExpiredTokenError | string) {

    if (typeof error === 'string') {
      this.toastService.openErrorToastMessage(error);
    } else if (error instanceof ExpiredTokenError) {
      // AuthStateService already logged out and redirected, once for all pending requests
    } else {

      const errorResponse = error as HttpErrorResponse;
      let errorMessage: string = "";

      if (errorResponse.status === 0) {
        errorMessage = 'ERROR.CONNECTION_ERROR';

      } else if (errorResponse.status === 403) {
        errorMessage = 'ERROR.FORBIDDEN';

      } else {
        errorMessage = 'ERROR.GENERIC_ERROR';
      }

      this.toastService.openTranslatedErrorToastMessage(errorMessage);

    }

    return error;
  }

}
